/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

import { AGENT_ID_QUERY_KEY } from '~/features/agents/constants'
import { sessionStore } from '~/store'

export const useSetAgentId = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const setAgentInStore = sessionStore((state) => state.setAgent)

  return useCallback(
    (agentId: string | undefined | null) => {
      const newSearchParams = new URLSearchParams(searchParams)

      if (!agentId) {
        newSearchParams.delete(AGENT_ID_QUERY_KEY)
      } else {
        newSearchParams.set(AGENT_ID_QUERY_KEY, agentId)
      }

      setSearchParams(newSearchParams)
      setAgentInStore({ id: agentId || undefined })
    },
    [searchParams, setAgentInStore, setSearchParams],
  )
}
